import { render, staticRenderFns } from "./BoutiqueExerpt.vue?vue&type=template&id=749dcb17&"
import script from "./BoutiqueExerpt.vue?vue&type=script&lang=js&"
export * from "./BoutiqueExerpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ILocalize: require('/opt/build/repo/components/svg/Localize.vue').default})
